export enum ReactQueryKey {
  GET_CURRENT_USER = "GET_CURRENT_USER",
  GET_CLIENT_ACCOUNT = "GET_CLIENT_ACCOUNT",
  GET_ORG_TITLES = "GET_ORG_TITLES",
  GET_ROLES = "GET_ROLES",
  GET_VENDORS = "GET_VENDORS",
  GET_USERS = "GET_USERS",
  GET_WORKSPACES = "GET_WORKSPACES",
  GET_NOTIFICATION_PREFERENCES = "GET_NOTIFICATION_PREFERENCES",
  GET_CATEGORIES = "GET_CATEGORIES",
}

export enum TdmReactQueryKey {
  GET_SHERPA_PROJECT_TDMS = "GET_SHERPA_PROJECT_TDMS",
  GET_PROJECT_TASKS = "GET_PROJECT_TASKS",
  GET_PROJECT_DELIVERABLES = "GET_PROJECT_DELIVERABLES",
  GET_PROJECT_MILESTONES = "GET_PROJECT_MILESTONES",
  GET_PROJECT_TASK = "GET_PROJECT_TASK",
  GET_PROJECT_DELIVERABLE = "GET_PROJECT_DELIVERABLE",
  GET_PROJECT_MILESTONE = "GET_PROJECT_MILESTONE",
  GET_APPLICATION_TASKS = "GET_APPLICATION_TASKS",
  GET_APPLICATION_DELIVERABLES = "GET_APPLICATION_DELIVERABLES",
  GET_APPLICATION_MILESTONES = "GET_APPLICATION_MILESTONES",
}

export enum SherpaProjectReactQueryKey {
  GET_PROJECT = "GET_PROJECT",
  GET_PROJECT_PHASES = "GET_PROJECT_PHASES",
  GET_PROJECT_PHASE_MEMBERS = "GET_PROJECT_PHASE_MEMBERS",
  GET_PROJECT_MEMBERS = "GET_PROJECT_MEMBERS",
  GET_PROJECT_EVENTS = "GET_PROJECT_EVENTS",
  GET_PROJECT_ASSETS = "GET_PROJECT_ASSETS",
  GET_PROJECT_PHASE_PICTURES = "GET_PROJECT_PHASE_PICTURES",
  GET_PROJECT_TEMPLATES = "GET_PROJECT_TEMPLATES",
  GET_PROJECT_TEMPLATE = "GET_PROJECT_TEMPLATE",
  GET_PROJECT_DRAWS = "GET_PROJECT_DRAWS",
  GET_PROJECT_DRAW = "GET_PROJECT_DRAW",
  GET_PROJECT_DOCUMENTS = "GET_PROJECT_DOCUMENTS",
  GET_PROJECT_DOCUMENT = "GET_PROJECT_DOCUMENT",
  GET_PROJECT_INVOICES = "GET_PROJECT_INVOICES",
  GET_PROJECT_INVOICE = "GET_PROJECT_INVOICE",
  GET_DRAW_LIST = "GET_DRAW_LIST"
}

export enum RoverReactQueryKey {
  GET_APPLICATION_FORMS = "GET_APPLICATION_FORMS",
  GET_APPLICATION_FORM_DETAILS = "GET_APPLICATION_FORM_DETAILS",
  GET_RESOURCE = "GET_RESOURCE",
  GET_APPLICATIONS = "GET_APPLICATIONS",
  GET_APPLICATION_DETAILS = "GET_APPLICATION_DETAILS",
  GET_APPLICATION_EVENTS = "GET_APPLICATION_EVENTS",
  GET_CLIENT_APPLICATIONS_DASHBOARD = "GET_CLIENT_APPLICATIONS_DASHBOARD",
  GET_PARTNER_PROPOSALS_DASHBOARD = "GET_PARTNER_PROPOSALS_DASHBOARD",
  GET_APPLICATIONS_TEAM_MEMBERS = "GET_APPLICATIONS_TEAM_MEMBERS",
  GET_ROVER_MILESTONES = "GET_ROVER_MILESTONE",
  GET_ROVER_TASKS = "GET_ROVER_TASK",
  GET_ROVER_DELIVERABLES = "GET_ROVER_DELIVERABLE",
  GET_APPLICATION_ASSETS = "GET_APPLICATION_ASSETS",
  GET_ROVER_TASK_ASSETS = "GET_ROVER_TASK_ASSETS",
  GET_ROVER_DELIVERABLE_ASSETS = "GET_ROVER_DELIVERABLE_ASSETS",
  GET_ROVER_MILESTONE_ASSETS = "GET_ROVER_MILESTONE_ASSETS",
}
